import React from 'react';
import {WideHeader} from '../../layout/wide';

interface Partner {
  name: string;
  logo: string;
  description: string;
  link: string;
  external: boolean;
}

const PARTNERS: Partner[] = [
  {
    name: 'Międzyuczelniane Centrum Badań Witrażowych',
    logo: '/images/partners/mcbw.svg',
    description: 'Międzyuczelniane Centrum Badań Witrażowych to konsorcjum naukowe powołane przez Uniwersytet Jagielloński i Akademię Sztuk Pięknych w Krakowie. Jego głównym celem jest inicjowanie, prowadzenie i koordynowanie interdyscyplinarnych badań nad sztuką witrażową, a także związana z nimi działalność ekspercka, edukacyjna i promocyjna.',
    link: '/mcbw',
    external: false
  },
  {
    name: 'Narodowy Program Rozwoju Humanistyki',
    logo: '/images/partners/nprh.svg',
    description: 'Narodowy Program Rozwoju Humanistyki (NPRH) to program ministerialny, którego przedmiotem jest finansowanie w trybie konkursowym projektów badawczych o istotnym znaczeniu dla polityki naukowej państwa. Program wspiera wieloletnie badania nad dziedzictwem kulturowym, humanistyczne analizy współczesnych wyzwań cywilizacyjnych oraz działania popularyzujące wyniki badań naukowych.',
    link: 'https://www.gov.pl/web/nauka/narodowy-program-rozwoju-humanistyki',
    external: true
  },
  {
    name: 'Uniwersytet Jagielloński',
    logo: '/images/partners/uj.svg',
    description: 'Uniwersytet Jagielloński (UJ) to najstarsza uczelnia w Polsce i jedna z najstarszych w Europie, założona w 1364 roku w Krakowie przez króla Kazimierza Wielkiego. Uznawany za jeden z najważniejszych polskich ośrodków akademickich i badawczych, kształci studentów na 16 wydziałach, w tym w ramach renomowanego Collegium Medicum.',
    link: 'https://www.uj.edu.pl/',
    external: true
  }
];

const Partners: React.FC = () => {
  return (
    <>
      <WideHeader
        title="Partners"
        introduction="Our partners and collaborators supporting stained glass research"
        narrow={true}
      />

      <section className="bg-gray-100 py-8">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="space-y-8">
            {PARTNERS.map((partner, index) => (
              <a
                key={index}
                href={partner.link}
                target={partner.external ? '_blank' : '_self'}
                rel={partner.external ? 'noopener noreferrer' : undefined}
                className="block bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 p-6"
              >
                <div className="flex flex-col md:flex-row gap-6 items-start">
                  <div className="flex-shrink-0 w-full md:w-48 flex items-center justify-center">
                    <img
                      src={partner.logo}
                      alt={partner.name}
                      className="max-w-full h-auto max-h-32 object-contain"
                    />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-cinzel font-bold text-gray-900 mb-3">
                      {partner.name}
                    </h3>
                    <p className="text-gray-700 leading-relaxed">
                      {partner.description}
                    </p>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Partners;

